/* src/app/builder-screen-beta/palette/palette.component.scss */
:host {
  display: block;
  height: 100%;
  overflow: hidden;
}
nz-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 8px;
  box-sizing: border-box;
}
nz-tabs ::ng-deep .ant-tabs-nav {
  flex-shrink: 0;
  margin-bottom: 8px;
}
nz-tabs ::ng-deep .ant-tabs-content-holder {
  flex: 1;
  overflow-y: auto !important;
  overflow-x: hidden;
  min-height: 0;
}
nz-tabs ::ng-deep .ant-tabs-content-holder::-webkit-scrollbar {
  width: 6px;
}
nz-tabs ::ng-deep .ant-tabs-content-holder::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
nz-tabs ::ng-deep .ant-tabs-content-holder::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
nz-tabs ::ng-deep .ant-tabs-content-holder::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
nz-tabs ::ng-deep .ant-tabs-tabpane {
  height: auto;
}
.palette-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 4px;
}
.palette-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 4px;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 64px;
}
.palette-item:hover {
  background: #e6f7ff;
  border-color: #91d5ff;
}
.palette-item:active {
  background: #bae7ff;
  transform: scale(0.96);
}
.palette-icon {
  font-size: 24px;
  color: #595959;
}
.palette-item:hover .palette-icon {
  color: #1890ff;
}
.palette-label {
  font-size: 11px;
  font-weight: 500;
  color: #595959;
  text-align: center;
  line-height: 1.2;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.palette-item:hover .palette-label {
  color: #1890ff;
}
/*# sourceMappingURL=palette.component.css.map */
